// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.help-support-page {
  padding: 24px;
  width: 100%;
  min-height: 100%;
}

.help-support-card {
  margin-top: 24px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  box-shadow: rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.help-support-card__header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 16px 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: start;
}

.help-support-card__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  flex-shrink: 0;
  border-radius: 50%;
}
.help-support-card__icon--bug {
  background: #fee2e2;
  color: #e53935;
}
.help-support-card__icon--feature {
  background: #fef9c3;
  color: #92400e;
}
.help-support-card__icon--support {
  background: #dbeafe;
  color: #2c68ad;
}

.help-support-card__heading {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.help-support-card__title {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
}

.help-support-card__subtitle {
  font-size: 12px;
  color: #6b7280;
}

.help-support-card__chevron {
  flex-shrink: 0;
  margin-top: 4px;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.help-support-card__chevron--open {
  transform: rotate(180deg);
}

.help-support-card__body {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 24px 24px;
  border-top: 1px solid #e5e7eb;
  padding-top: 24px;
}

.help-support-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.help-support-row {
  display: flex;
  gap: 16px;
}
.help-support-row .help-support-field {
  flex: 1 1;
  min-width: 0;
}
.help-support-row .help-support-field--half {
  flex: 0 0 50%;
  max-width: 50%;
}
.help-support-row .help-support-select.custom-dropdown {
  max-width: 100%;
}

.help-support-field__label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.help-support-field__required {
  color: #e53935;
  margin-inline-start: 2px;
}

.help-support-field__label-row {
  display: flex;
  align-items: center;
  gap: 4px;
}

.help-support-field__hint {
  margin: -4px 0 0;
  font-size: 12px;
  color: #6b7280;
}

.help-support-input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #CCD9F0;
  border-radius: 8px;
  background: #f5faff;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 14px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.help-support-input::placeholder {
  color: #9ca3af;
}
.help-support-input:focus {
  outline: none;
  border-color: #2c68ad;
  box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.15);
  background: #ffffff;
}

.help-support-select.custom-dropdown {
  width: 100%;
  max-width: 320px;
}

.help-support-textarea {
  width: 100%;
  min-height: 120px;
  padding: 12px 16px;
  border: 1px solid #CCD9F0;
  border-radius: 8px;
  background: #f5faff;
  color: #1a1a1a;
  font-family: inherit;
  font-size: 14px;
  resize: vertical;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.help-support-textarea.ant-input {
  height: auto !important;
  min-height: 120px;
  padding: 12px 16px !important;
}
.help-support-textarea::placeholder {
  color: #9ca3af;
}
.help-support-textarea:focus {
  outline: none;
  border-color: #2c68ad;
  box-shadow: 0 0 0 3px rgba(44, 104, 173, 0.15);
  background: #ffffff;
}
.help-support-textarea--error, .help-support-textarea--error.ant-input, .help-support-textarea--error:focus {
  border-color: #e53935;
  box-shadow: none;
}

.help-support-charcount-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px;
  margin-top: 4px;
  font-size: 12px;
  color: #6b7280;
}

.help-support-charcount--error {
  color: #e53935;
  font-weight: 600;
}

.help-support-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 24px;
  min-height: 140px;
  border: 1.5px dashed #CCD9F0;
  border-radius: 8px;
  background: #f5faff;
  color: #6b7280;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.help-support-dropzone:hover, .help-support-dropzone--active {
  border-color: #2c68ad;
  background: #eff6ff;
}

.help-support-dropzone__icon {
  color: #9ca3af;
}

.help-support-dropzone__text {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}

.help-support-dropzone__browse {
  color: #2c68ad;
  font-weight: 600;
}

.help-support-dropzone__hint {
  margin: 0;
  font-size: 10px;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: #9ca3af;
}

.help-support-dropzone__input {
  display: none;
}

.help-support-files {
  list-style: none;
  margin: 8px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.help-support-files__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  background: #f5f6f8;
}

.help-support-files__name-wrap {
  display: flex;
  align-items: center;
  gap: 4px;
  overflow: hidden;
}

.help-support-files__check {
  flex-shrink: 0;
  color: #28a745;
}

.help-support-files__name {
  font-size: 12px;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.help-support-files__remove {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
}
.help-support-files__remove:hover {
  color: #e53935;
  background: #fee2e2;
}

.help-support-submit-row {
  display: flex;
  align-items: center;
  gap: 8px;
  align-self: flex-start;
}

.help-support-submit-spinner {
  display: inline-flex;
  align-items: center;
}

.help-support-submit {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border: none;
  border-radius: 8px;
  background: #2c68ad;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease;
}
.help-support-submit:hover:not(:disabled) {
  background: #2a73c2;
}
.help-support-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.help-support-faq {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.help-support-faq__item {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #e5e7eb;
  padding: 0;
}
.help-support-faq__item:last-child {
  border-bottom: none;
}

.help-support-faq__question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 14px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  text-align: start;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
}

.help-support-faq__chevron {
  flex-shrink: 0;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.help-support-faq__chevron--open {
  transform: rotate(180deg);
}

.help-support-faq__answer {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
  padding: 8px 16px;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
  background: #f5f6f8;
}

.help-support-faq__answer-text {
  margin: 0;
}

.help-support-faq__list {
  margin: 4px 0 0;
  padding-inline-start: 16px;
}
.help-support-faq__list li {
  margin-bottom: 4px;
}
.help-support-faq__list li:last-child {
  margin-bottom: 0;
}

.help-support-faq-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 10px;
}

.help-support-search {
  width: 40% !important;
  flex-shrink: 0;
}

@media (max-width: 576px) {
  .help-support-faq-header {
    flex-direction: column;
    align-items: stretch;
  }
  .help-support-search {
    width: 100%;
  }
}
.help-support-faq-categories {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.help-support-faq-category {
  display: flex;
  flex-direction: column;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
}

.help-support-faq-category__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  padding: 12px 16px;
  background: #f5f6f8;
  border: none;
  cursor: pointer;
  text-align: start;
  font-size: 14px;
  font-weight: 600;
  color: #1a1a1a;
  transition: background 0.15s ease;
}
.help-support-faq-category__header:hover {
  background: #eff6ff;
}

.help-support-faq-category__title {
  display: flex;
  align-items: baseline;
  gap: 8px;
  min-width: 0;
}

.help-support-faq-category__num {
  color: #2c68ad;
  font-weight: 600;
}

.help-support-faq-category__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.help-support-faq-category__count {
  min-width: 22px;
  padding: 1px 8px;
  border-radius: 50%;
  background: #dbeafe;
  color: #2c68ad;
  font-size: 10px;
  font-weight: 600;
  text-align: center;
}

.help-support-faq--nested {
  border: none;
  border-radius: 0;
  border-top: 1px solid #e5e7eb;
}

@media (max-width: 768px) {
  .help-support-page {
    padding: 16px;
  }
  .help-support-card__header,
  .help-support-card__body {
    padding-left: 16px;
    padding-right: 16px;
  }
  .help-support-row {
    flex-direction: column;
  }
  .help-support-field--half {
    flex: 1 1;
    max-width: 100%;
  }
  .help-support-select.custom-dropdown {
    max-width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/layouts/HelpSupport/HelpSupport.scss","webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aC0MW;EDzMX,WAAA;EACA,gBAAA;AADF;;AAIA;EACE,gBCoMW;EDnMX,mBCGM;EDFN,yBAAA;EACA,mBCsMU;EDrMV,+BC0LgB;EDzLhB,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,uBAAA;EACA,SCuLW;EDtLX,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBCgLa;ADjLf;AAGE;EACE,mBC0IW;EDzIX,cCVK;ADST;AAIE;EACE,mBCwIW;EDvIX,cCsEW;ADxEf;AAKE;EACE,mBC2FW;ED1FX,cChDY;AD6ChB;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AAJF;;AAOA;EACE,eC4Ja;ED3Jb,gBC8JqB;ED7JrB,cC/Ca;AD2Cf;;AAOA;EACE,eCoJa;EDnJb,cCnDe;AD+CjB;;AAOA;EACE,cAAA;EACA,eAAA;EACA,cCxDW;EDyDX,+BAAA;AAJF;;AAOA;EACE,yBAAA;AAJF;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,SCsHW;EDrHX,oBAAA;EACA,6BAAA;EACA,iBCmHW;ADvHb;;AAOA;EACE,aAAA;EACA,sBAAA;EACA,QC0GW;AD9Gb;;AAOA;EACE,aAAA;EACA,SCuGW;AD3Gb;AAME;EACE,SAAA;EACA,YAAA;AAJJ;AAOE;EACE,aAAA;EACA,cAAA;AALJ;AAQE;EACE,eAAA;AANJ;;AAUA;EACE,eCkGa;EDjGb,gBCsGqB;EDrGrB,cC1Ba;ADmBf;;AAUA;EACE,cC/FO;EDgGP,wBAAA;AAPF;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,QCqEW;AD5Eb;;AAUA;EACE,gBAAA;EACA,eCgFa;ED/Eb,cCvHe;ADgHjB;;AAUA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBCgEU;ED/DV,mBCoBa;EDnBb,cCjIa;EDkIb,oBAAA;EACA,eCqEa;EDpEb,0DAAA;AAPF;AASE;EACE,cCrIS;AD8Hb;AAUE;EACE,aAAA;EACA,qBC5JY;ED6JZ,8CAAA;EACA,mBCnJI;AD2IR;;AAYA;EACE,WAAA;EACA,gBAAA;AATF;;AAYA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBCmCU;EDlCV,mBCTa;EDUb,cC9Ja;ED+Jb,oBAAA;EACA,eCwCa;EDvCb,gBAAA;EACA,0DAAA;AATF;AAeE;EACE,uBAAA;EACA,iBAAA;EACA,6BAAA;AAbJ;AAgBE;EACE,cC7KS;AD+Jb;AAiBE;EACE,aAAA;EACA,qBCpMY;EDqMZ,8CAAA;EACA,mBC3LI;AD4KR;AAkBE;EAGE,qBChLK;EDiLL,gBAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,QCdW;EDeX,eCfW;EDgBX,eAAA;EACA,cCvMe;ADoLjB;;AAuBE;EACE,cCjMK;EDkML,gBCFmB;ADlBvB;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QChCW;EDiCX,aC7BW;ED8BX,iBAAA;EACA,4BAAA;EACA,kBC5BU;ED6BV,mBCxEa;EDyEb,cC5Ne;ED6Nf,eAAA;EACA,0DAAA;AArBF;AAuBE;EAEE,qBCnPY;EDoPZ,mBCzFW;ADmEf;;AA0BA;EACE,cCvOW;ADgNb;;AA0BA;EACE,SAAA;EACA,eCtCa;EDuCb,cC9Oe;ADuNjB;;AA0BA;EACE,cCnQc;EDoQd,gBCxCqB;ADiBvB;;AA0BA;EACE,SAAA;EACA,eCnDa;EDoDb,sBAAA;EACA,yBAAA;EACA,cC1PW;ADmOb;;AA0BA;EACE,aAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,QClFW;AD2Db;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QCxFW;EDyFX,iBAAA;EACA,yBAAA;EACA,kBCrFU;EDsFV,mBCxRmB;ADiQrB;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,QCnGW;EDoGX,gBAAA;AAvBF;;AA0BA;EACE,cAAA;EACA,cCjRQ;AD0PV;;AA0BA;EACE,eC7Fa;ED8Fb,cCrSa;EDsSb,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvBF;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,cChTe;EDiTf,eAAA;EACA,YAAA;EACA,kBCtHU;AD+FZ;AAyBE;EACE,cC3SK;ED4SL,mBCzJW;ADkIf;;AA2BA;EACE,aAAA;EACA,mBAAA;EACA,QCvIW;EDwIX,sBAAA;AAxBF;;AA2BA;EACE,oBAAA;EACA,mBAAA;AAxBF;;AA2BA;EACE,oBAAA;EACA,mBAAA;EACA,QCnJW;EDoJX,kBAAA;EACA,YAAA;EACA,kBC/IU;EDgJV,mBC/Vc;EDgWd,cC7Ua;ED8Ub,eCzIa;ED0Ib,gBCtIqB;EDuIrB,eAAA;EACA,iCAAA;AAxBF;AA0BE;EACE,mBCtWkB;AD8UtB;AA2BE;EACE,YAAA;EACA,mBAAA;AAzBJ;;AA6BA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,kBCtKU;EDuKV,gBAAA;AA1BF;;AA6BA;EACE,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,UAAA;AA1BF;AA4BE;EACE,mBAAA;AA1BJ;;AA8BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SC/LW;EDgMX,WAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eCxLa;EDyLb,gBCrLqB;EDsLrB,cClYa;ADuWf;;AA8BA;EACE,cAAA;EACA,cCrYW;EDsYX,+BAAA;AA3BF;;AA8BA;EACE,yBAAA;AA3BF;;AA8BA;EACE,WAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,eC7Ma;ED8Mb,cCpZe;EDqZf,gBAAA;EACA,mBC3ZmB;ADgYrB;;AA8BA;EACE,SAAA;AA3BF;;AA8BA;EACE,eAAA;EACA,0BCtOW;AD2Mb;AA6BE;EACE,kBAAA;AA3BJ;AA6BI;EACE,gBAAA;AA3BN;;AAiCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SCvPW;EDwPX,oBAAA;AA9BF;;AAiCA;EACE,qBAAA;EACA,cAAA;AA9BF;;AAiCA;EACE;IACE,sBAAA;IACA,oBAAA;EA9BF;EAiCA;IACE,WAAA;EA/BF;AACF;AAmCA;EACE,aAAA;EACA,sBAAA;EACA,SC/QW;AD8Ob;;AAoCA;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBChRU;EDiRV,gBAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SC9RW;ED+RX,WAAA;EACA,kBAAA;EACA,mBC9dmB;ED+dnB,YAAA;EACA,eAAA;EACA,iBAAA;EACA,eCtRa;EDuRb,gBCnRqB;EDoRrB,cChea;EDieb,iCAAA;AAjCF;AAmCE;EACE,mBCzVW;ADwTf;;AAqCA;EACE,aAAA;EACA,qBAAA;EACA,QCnTW;EDoTX,YAAA;AAlCF;;AAqCA;EACE,cChgBc;EDigBd,gBCrSqB;ADmQvB;;AAqCA;EACE,aAAA;EACA,mBAAA;EACA,QC/TW;EDgUX,cAAA;AAlCF;;AAqCA;EACE,eAAA;EACA,gBAAA;EACA,kBC5Ta;ED6Tb,mBCrYa;EDsYb,cChhBc;EDihBd,eC3Ta;ED4Tb,gBCtTqB;EDuTrB,kBAAA;AAlCF;;AAsCA;EACE,YAAA;EACA,gBAAA;EACA,6BAAA;AAnCF;;AAsCA;EACE;IACE,aCrVS;EDkTX;EAsCA;;IAEE,kBC1VS;ID2VT,mBC3VS;EDuTX;EAuCA;IACE,sBAAA;EArCF;EAwCA;IACE,SAAA;IACA,eAAA;EAtCF;EAyCA;IACE,eAAA;EAvCF;AACF","sourcesContent":["@import \"../../styles/variables\";\n\n.help-support-page {\n  padding: $spacing-xl;\n  width: 100%;\n  min-height: 100%;\n}\n\n.help-support-card {\n  margin-top: $spacing-xl;\n  background: $white;\n  border: 1px solid $border-light;\n  border-radius: $radius-lg;\n  box-shadow: $shadow-black-06;\n  overflow: hidden;\n}\n\n.help-support-card__header {\n  display: flex;\n  align-items: flex-start;\n  gap: $spacing-md;\n  width: 100%;\n  padding: $spacing-lg $spacing-xl;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: start;\n}\n\n.help-support-card__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  flex-shrink: 0;\n  border-radius: $radius-round;\n\n  &--bug {\n    background: $color-fee2e2;\n    color: $danger;\n  }\n\n  &--feature {\n    background: $color-fef9c3;\n    color: $color-92400e;\n  }\n\n  &--support {\n    background: $color-dbeafe;\n    color: $brand-primary;\n  }\n}\n\n.help-support-card__heading {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.help-support-card__title {\n  font-size: $font-size-lg;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n}\n\n.help-support-card__subtitle {\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.help-support-card__chevron {\n  flex-shrink: 0;\n  margin-top: 4px;\n  color: $text-muted;\n  transition: transform 0.2s ease;\n}\n\n.help-support-card__chevron--open {\n  transform: rotate(180deg);\n}\n\n.help-support-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: $spacing-xl;\n  padding: 0 $spacing-xl $spacing-xl;\n  border-top: 1px solid $border-light;\n  padding-top: $spacing-xl;\n}\n\n.help-support-field {\n  display: flex;\n  flex-direction: column;\n  gap: $spacing-sm;\n}\n\n.help-support-row {\n  display: flex;\n  gap: $spacing-lg;\n\n  .help-support-field {\n    flex: 1;\n    min-width: 0;\n  }\n\n  .help-support-field--half {\n    flex: 0 0 50%;\n    max-width: 50%;\n  }\n\n  .help-support-select.custom-dropdown {\n    max-width: 100%;\n  }\n}\n\n.help-support-field__label {\n  font-size: $font-size-sm;\n  font-weight: $font-weight-semibold;\n  color: $color-374151;\n}\n\n.help-support-field__required {\n  color: $danger;\n  margin-inline-start: 2px;\n}\n\n.help-support-field__label-row {\n  display: flex;\n  align-items: center;\n  gap: $spacing-xs;\n}\n\n.help-support-field__hint {\n  margin: -$spacing-xs 0 0;\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.help-support-input {\n  width: 100%;\n  padding: $spacing-md $spacing-lg;\n  border: 1px solid $border-dropdown;\n  border-radius: $radius-md;\n  background: $color-f5faff;\n  color: $text-primary;\n  font-family: inherit;\n  font-size: $font-size-md;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  &::placeholder {\n    color: $text-muted;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: $brand-primary;\n    box-shadow: 0 0 0 3px $brand-primary-light;\n    background: $white;\n  }\n}\n\n.help-support-select.custom-dropdown {\n  width: 100%;\n  max-width: 320px;\n}\n\n.help-support-textarea {\n  width: 100%;\n  min-height: 120px;\n  padding: $spacing-md $spacing-lg;\n  border: 1px solid $border-dropdown;\n  border-radius: $radius-md;\n  background: $color-f5faff;\n  color: $text-primary;\n  font-family: inherit;\n  font-size: $font-size-md;\n  resize: vertical;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n  // The shared .styled-text-input.ant-input rule hardcodes height: 44px and\n  // padding: 0 12px for single-line inputs; that selector ties with ours on\n  // specificity, so !important guarantees this textarea keeps its own\n  // multi-line height and padding regardless of stylesheet import order.\n  &.ant-input {\n    height: auto !important;\n    min-height: 120px;\n    padding: $spacing-md $spacing-lg !important;\n  }\n\n  &::placeholder {\n    color: $text-muted;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: $brand-primary;\n    box-shadow: 0 0 0 3px $brand-primary-light;\n    background: $white;\n  }\n\n  &--error,\n  &--error.ant-input,\n  &--error:focus {\n    border-color: $danger;\n    box-shadow: none;\n  }\n}\n\n.help-support-charcount-row {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: $spacing-xs;\n  margin-top: $spacing-xs;\n  font-size: $font-size-sm;\n  color: $text-secondary;\n}\n\n.help-support-charcount {\n  &--error {\n    color: $danger;\n    font-weight: $font-weight-semibold;\n  }\n}\n\n.help-support-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: $spacing-xs;\n  padding: $spacing-xl;\n  min-height: 140px;\n  border: 1.5px dashed $border-dropdown;\n  border-radius: $radius-md;\n  background: $color-f5faff;\n  color: $text-secondary;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &:hover,\n  &--active {\n    border-color: $brand-primary;\n    background: $color-eff6ff;\n  }\n}\n\n.help-support-dropzone__icon {\n  color: $text-muted;\n}\n\n.help-support-dropzone__text {\n  margin: 0;\n  font-size: $font-size-md;\n  color: $text-secondary;\n}\n\n.help-support-dropzone__browse {\n  color: $brand-primary;\n  font-weight: $font-weight-semibold;\n}\n\n.help-support-dropzone__hint {\n  margin: 0;\n  font-size: $font-size-xs;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: $text-muted;\n}\n\n.help-support-dropzone__input {\n  display: none;\n}\n\n.help-support-files {\n  list-style: none;\n  margin: $spacing-sm 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: $spacing-xs;\n}\n\n.help-support-files__item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $spacing-sm;\n  padding: $spacing-sm $spacing-md;\n  border: 1px solid $border-light;\n  border-radius: $radius-sm;\n  background: $background-default;\n}\n\n.help-support-files__name-wrap {\n  display: flex;\n  align-items: center;\n  gap: $spacing-xs;\n  overflow: hidden;\n}\n\n.help-support-files__check {\n  flex-shrink: 0;\n  color: $success;\n}\n\n.help-support-files__name {\n  font-size: $font-size-sm;\n  color: $text-primary;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.help-support-files__remove {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: transparent;\n  color: $text-secondary;\n  cursor: pointer;\n  padding: 2px;\n  border-radius: $radius-sm;\n\n  &:hover {\n    color: $danger;\n    background: $color-fee2e2;\n  }\n}\n\n.help-support-submit-row {\n  display: flex;\n  align-items: center;\n  gap: $spacing-sm;\n  align-self: flex-start;\n}\n\n.help-support-submit-spinner {\n  display: inline-flex;\n  align-items: center;\n}\n\n.help-support-submit {\n  display: inline-flex;\n  align-items: center;\n  gap: $spacing-sm;\n  padding: 10px $spacing-xl;\n  border: none;\n  border-radius: $radius-md;\n  background: $brand-primary;\n  color: $text-inverse;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  cursor: pointer;\n  transition: background 0.15s ease;\n\n  &:hover:not(:disabled) {\n    background: $brand-primary-hover;\n  }\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n}\n\n.help-support-faq {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  overflow: hidden;\n}\n\n.help-support-faq__item {\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid $border-light;\n  padding: 0;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.help-support-faq__question {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $spacing-md;\n  width: 100%;\n  margin: 0;\n  padding: 14px 16px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-align: start;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n}\n\n.help-support-faq__chevron {\n  flex-shrink: 0;\n  color: $text-muted;\n  transition: transform 0.2s ease;\n}\n\n.help-support-faq__chevron--open {\n  transform: rotate(180deg);\n}\n\n.help-support-faq__answer {\n  width: 100%;\n  box-sizing: border-box;\n  margin: 0;\n  padding: $spacing-sm $spacing-lg;\n  font-size: $font-size-sm;\n  color: $text-secondary;\n  line-height: 1.5;\n  background: $background-default;\n}\n\n.help-support-faq__answer-text {\n  margin: 0;\n}\n\n.help-support-faq__list {\n  margin: $spacing-xs 0 0;\n  padding-inline-start: $spacing-lg;\n\n  li {\n    margin-bottom: 4px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n// FAQ header + search\n.help-support-faq-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $spacing-md;\n  padding-bottom: 10px;\n}\n\n.help-support-search {\n  width: 40% !important;\n  flex-shrink: 0;\n}\n\n@media (max-width: 576px) {\n  .help-support-faq-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .help-support-search {\n    width: 100%;\n  }\n}\n\n// FAQ category grouping\n.help-support-faq-categories {\n  display: flex;\n  flex-direction: column;\n  gap: $spacing-md;\n}\n\n.help-support-faq-category {\n  display: flex;\n  flex-direction: column;\n  border: 1px solid $border-light;\n  border-radius: $radius-md;\n  overflow: hidden;\n}\n\n.help-support-faq-category__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: $spacing-md;\n  width: 100%;\n  padding: $spacing-md $spacing-lg;\n  background: $background-default;\n  border: none;\n  cursor: pointer;\n  text-align: start;\n  font-size: $font-size-md;\n  font-weight: $font-weight-semibold;\n  color: $text-primary;\n  transition: background 0.15s ease;\n\n  &:hover {\n    background: $color-eff6ff;\n  }\n}\n\n.help-support-faq-category__title {\n  display: flex;\n  align-items: baseline;\n  gap: $spacing-sm;\n  min-width: 0;\n}\n\n.help-support-faq-category__num {\n  color: $brand-primary;\n  font-weight: $font-weight-semibold;\n}\n\n.help-support-faq-category__meta {\n  display: flex;\n  align-items: center;\n  gap: $spacing-sm;\n  flex-shrink: 0;\n}\n\n.help-support-faq-category__count {\n  min-width: 22px;\n  padding: 1px 8px;\n  border-radius: $radius-round;\n  background: $color-dbeafe;\n  color: $brand-primary;\n  font-size: $font-size-xs;\n  font-weight: $font-weight-semibold;\n  text-align: center;\n}\n\n// FAQ list nested inside a category card\n.help-support-faq--nested {\n  border: none;\n  border-radius: 0;\n  border-top: 1px solid $border-light;\n}\n\n@media (max-width: 768px) {\n  .help-support-page {\n    padding: $spacing-lg;\n  }\n\n  .help-support-card__header,\n  .help-support-card__body {\n    padding-left: $spacing-lg;\n    padding-right: $spacing-lg;\n  }\n\n  .help-support-row {\n    flex-direction: column;\n  }\n\n  .help-support-field--half {\n    flex: 1;\n    max-width: 100%;\n  }\n\n  .help-support-select.custom-dropdown {\n    max-width: 100%;\n  }\n}\n","\n// 🎨 Brand Colors\n$brand-primary: #2c68ad;\n$brand-primary-hover: #2a73c2;\n$brand-primary-strong: #3079bb;\n$brand-primary-light: rgba(44, 104, 173, 0.15);\n$blue-300: #023e8a;\n$blue-400: #03045e;\n$blue-base: #1e3a8a;\n$secondary-blue: #4a90e2;\n$color-1d4ed8: #1d4ed8;\n$color-64748b: #64748b;\n// ⚪ Background / Neutral\n$white: #ffffff;\n$background-default: #f5f6f8;\n$background-light: #fafafa;\n\n// 📝 Text\n$text-primary: #1a1a1a;\n$text-secondary: #6b7280;\n$text-muted: #9ca3af;\n$text-inverse: #ffffff;\n$text-dark: #000000;\n\n// 🧱 Borders\n$border-light: #e5e7eb;\n$border-default: #cbd5e1;\n$border-dark: #9ca3af;\n$border-dropdown: #CCD9F0;\n// 🔴 Status Colors\n$danger: #e53935;\n$danger-hover: #bf3936;\n$text-color: #1a202c;\n$success: #28a745;\n$success-hover: #0cc036;\n$green-100: #d3f9d8;\n$green-700: #2e7d32;\n$gray: #f7f9fc;\n$disabled-gray: #c2c2c2;\n$gray-200: #eeeeee;\n$gray-700: #616161;\n$warning: #ff6c00;\n$chart-primary: $color-1d4ed8;\n$chart-secondary: #0f766e;\n$chart-tertiary: #4338ca;\n$chart-success: $success;\n$chart-warning: $warning;\n$chart-danger: $danger;\n$chart-neutral: $color-64748b;\n$chart-grid-stroke: #e4e8ef;\n$chart-axis-stroke: #d7dde7;\n$chart-tooltip-cursor: rgba(15, 74, 151, 0.08);\n$orange-100: #ff9100;\n$orange-200: #ff6d00;\n$color-003a8c: #003a8c;\n$color-0050b3: #0050b3;\n$color-007bff: #007bff;\n$color-0088cc: #0088cc;\n$color-00a2cc: #00a2cc;\n$color-0172cb: #0172cb;\n$color-04c85e: #04c85e;\n$color-065f46: #065f46;\n$color-0d3b66: #0d3b66;\n$color-f2f2f2: #f2f2f2;\n$color-1c60c6: #1c60c6;\n$color-0d47a1: #0d47a1;\n$color-114b8a: #114b8a;\n$color-130054: #130054;\n$color-140054: #140054;\n$color-145da0: #145da0;\n$color-150054: #150054;\n$color-1565c0: #1565c0;\n$color-165ec9: #165ec9;\n$color-1890ff: #1890ff;\n$color-1977f3: #1977f3;\n$color-1a1a1a: #1a1a1a;\n$color-1b3a57: #1b3a57;\n$color-1d4ed8: #1d4ed8;\n$color-1d5aa1: #1d5aa1;\n$color-1e2a38: #1e2a38;\n$color-1e88e5: #1e88e5;\n$color-1f2d3d: #1f2d3d;\n$color-1f3b65: #1f3b65;\n$color-2196f3: #2196f3;\n$color-222: #222;\n$color-2563eb: #2563eb;\n$color-2596be: #2596be;\n$color-2979ff: #2979ff;\n$color-2a99b4: #2a99b4;\n$color-2b68ad: #2b68ad;\n$color-2c5bbd: #2c5bbd;\n$color-2d4373: #2d4373;\n$color-2e7d32: #2e7d32;\n$color-333: #333;\n$color-34d399: #34d399;\n$color-374151: #374151;\n$color-38abd2: #38abd2;\n$color-3b5998: #3b5998;\n$color-3b82f6: #3b82f6;\n$color-3ec3f0: #3ec3f0;\n$color-40a9ff: #40a9ff;\n$color-475569: #475569;\n$color-4e6a8a: #4e6a8a;\n$color-4f5e71: #4f5e71;\n$color-555: #555;\n$color-595959: #595959;\n$color-64748b: #64748b;\n$color-64b5f6: #64b5f6;\n$color-666: #666;\n$color-718096: #718096;\n$color-75ceeb: #75ceeb;\n$color-777: #777;\n$color-888: #888;\n$color-90caf9: #90caf9;\n$color-91d5ff: #91d5ff;\n$color-92400e: #92400e;\n$color-93c5fd: #93c5fd;\n$color-94a3b8: #94a3b8;\n$color-999: #999;\n$color-a0aec0: #a0aec0;\n$color-a6c1f3: #a6c1f3;\n$color-b91c1c: #b91c1c;\n$color-bac7d5: #bac7d5;\n$color-bae7ff: #bae7ff;\n$color-bbdefb: #bbdefb;\n$color-bbf7d0: #bbf7d0;\n$color-bfdbfe: #bfdbfe;\n$color-c1d6f5: #c1d6f5;\n$color-c7d2fe: #c7d2fe;\n$color-c8e6c9: #c8e6c9;\n$color-cbd5e1: #cbd5e1;\n$color-ccc: #ccc;\n$color-ccd9f0: #ccd9f0;\n$color-d21c1c: #d21c1c;\n$color-d32f2f: #d32f2f;\n$color-d3d3d3: #d3d3d3;\n$color-d93025: #d93025;\n$color-d9d9d9: #d9d9d9;\n$color-d9e2f3: #d9e2f3;\n$color-dbe9ff: #dbe9ff;\n$color-dbeafe: #dbeafe;\n$color-dbeeff: #dbeeff;\n$color-ddd: #ddd;\n$color-e0e0e0: #e0e0e0;\n$color-e0e7ff: #e0e7ff;\n$color-e3f2fd: #e3f2fd;\n$color-e4e4e4: #e4e4e4;\n$color-e53e3e: #e53e3e;\n$color-e5e7eb: #e5e7eb;\n$color-e6f0ff: #e6f0ff;\n$color-e6f4ff: #e6f4ff;\n$color-e6f7ff: #e6f7ff;\n$color-e6f9f0: #e6f9f0;\n$color-e8e8e8: #e8e8e8;\n$color-e8f5e9: #e8f5e9;\n$color-e9effa: #e9effa;\n$color-ecfdf5: #ecfdf5;\n$color-eff6ff: #eff6ff;\n$color-f0f0f0: #f0f0f0;\n$color-f0f2f5: #f0f2f5;\n$color-f0f4ff: #f0f4ff;\n$color-f0f8ff: #f0f8ff;\n$color-f0f9ff: #f0f9ff;\n$color-f1f5f9: #f1f5f9;\n$color-f3f3f3: #f3f3f3;\n$color-f3f4f6: #f3f4f6;\n$color-f5faff: #f5faff;\n$color-f6f9fc: #f6f9fc;\n$color-f87171: #f87171;\n$color-f8f9fa: #f8f9fa;\n$color-f9ee24: #f9ee24;\n$color-f9f9f9: #f9f9f9;\n$color-f9fafb: #f9fafb;\n$color-facc15: #facc15;\n$color-fafafa: #fafafa;\n$color-fde2e2: #fde2e2;\n$color-fecaca: #fecaca;\n$color-fee2e2: #fee2e2;\n$color-fef08a: #fef08a;\n$color-fef2f2: #fef2f2;\n$color-fef9c3: #fef9c3;\n$color-ff4d4f: #ff4d4f;\n$color-ff7875: #ff7875;\n$color-ffcdd2: #ffcdd2;\n$color-ffe0b2: #ffe0b2;\n$color-ffebee: #ffebee;\n$border-color: #cbd5e0;\n$color-00000033: #00000033;\n// 🌫 Shadows\n$shadow-sm: 0 2px 4px rgba(0, 0, 0, 0.08);\n$shadow-md: 0 4px 8px rgba(0, 0, 0, 0.12);\n$shadow-lg: 0 8px 16px rgba(0, 0, 0, 0.2);\n$shadow-button: 0 3px 6px rgba(0, 0, 0, 0.12);\n$shadow-button-subtle: 0 2px 4px rgba(182, 178, 178, 0.6);\n$shadow-gray-600: rgba(182, 178, 178, 0.6);\n$shadow-gray-800: rgba(182, 178, 178, 0.8);\n$shadow-blue-200: rgba(24, 144, 255, 0.2);\n$shadow-black-10: rgba(0, 0, 0, 0.1);\n$shadow-black-08: rgba(0, 0, 0, 0.08);\n$shadow-black-06: rgba(0, 0, 0, 0.06);\n// 📏 Spacing\n$spacing-xs: 4px;\n$spacing-sm: 8px;\n$spacing-md: 12px;\n$spacing-lg: 16px;\n$spacing-xl: 24px;\n\n// ⭕ Border Radius\n$radius-sm: 4px;\n$radius-md: 8px;\n$radius-lg: 12px;\n$radius-xl: 20px;\n$radius-round: 50%;\n\n// 🔤 Font\n$font-family: 'Open Sans', sans-serif;\n$font-size-xs: 10px;\n$font-size-sm: 12px;\n$font-size-md: 14px;\n$font-size-lg: 16px;\n$font-size-xl: 20px;\n$font-weight-normal: 400;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n\n//dashboards\n$dt-primary: #2b74e4;\n$dt-primary-hover: #1f5fc4;\n$dt-text: #1a1a1a;\n$dt-text-secondary: #6b7280;\n$dt-text-muted: #9ca3af;\n$dt-border: #e5e7eb;\n$dt-bg: #f5f6f8;\n$dt-bg-light: #f8fafc;\n$dt-success: #28a745;\n$dt-danger: #e53935;\n$dt-warning: #ff6c00;\n// Chart-palette hues reused by DOM elements (status badges, platform swatches).\n// Keep in sync with CHART_COLOR_PALETTE in src/components/charts/chartPalette.ts.\n$dt-purple: #8d4fd3;\n$dt-google-amber: #f6c15f;\n$paid-media-accent: rgb(43, 104, 173);\n$paid-media-accent-hover: rgb(43, 104, 173);"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
